import { unknownToError } from '@vortex/shared';
import { toPromise } from "../../../util/util";
export function removeMod(api, gameId, modId) {
    return new Promise((resolve, reject) => {
        api.events.emit("remove-mod", gameId, modId, (err) => {
            if (err) {
                reject(unknownToError(err));
            }
            else {
                resolve();
            }
        });
    });
}
export function removeMods(api, gameId, modIds) {
    if (modIds.length === 0) {
        return Promise.resolve();
    }
    const notiParams = {
        type: "activity",
        title: "Removing mods",
        message: "...",
        progress: 0,
    };
    notiParams.id = api.sendNotification({
        ...notiParams,
    });
    const progressCB = (idx, length, name) => {
        api.sendNotification({
            ...notiParams,
            message: name,
            progress: (idx * 100) / length,
        });
    };
    return Promise.resolve(toPromise((cb) => api.events.emit("remove-mods", gameId, modIds, cb, { progressCB })))
        .then(() => {
        api.events.emit("mods-enabled", modIds, false, gameId);
    })
        .finally(() => {
        api.dismissNotification(notiParams.id);
    });
}
